import api from './http';

export const getOtoCapabilities = () => api.get('/oto/capabilities');
export const getOtoSessions = () => api.get('/oto/sessions');
export const createOtoSession = () => api.post('/oto/sessions', { title: 'Nouvelle discussion' });
export const getOtoSession = id => api.get(`/oto/sessions/${id}`);
export const archiveOtoSession = id => api.delete(`/oto/sessions/${id}`);
export const confirmOtoProposal = proposal => api.post(`/oto/proposals/${proposal.id}/confirm`, { confirmed: true, acknowledge_effects: true, fingerprint: proposal.fingerprint }, { timeout: 120000 });
export const cancelOtoProposal = id => api.post(`/oto/proposals/${id}/cancel`);
export const transcribeOtoAudio = (file, signal) => {
  const form = new FormData(); form.append('file', file);
  return api.post('/oto/transcribe', form, { headers: { 'Content-Type': 'multipart/form-data' }, signal, timeout: 85000 });
};

export const listOtoAttachments = sessionId => api.get(`/oto/sessions/${sessionId}/attachments`);
export const uploadOtoAttachment = (sessionId, file) => {
  const form = new FormData(); form.append('file', file);
  return api.post(`/oto/sessions/${sessionId}/attachments`, form, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 180000 });
};
export const downloadOtoAttachment = (sessionId, id) => api.get(`/oto/sessions/${sessionId}/attachments/${id}/download`, { responseType: 'blob', timeout: 85000 });

export const listOtoMemories = () => api.get('/oto/memories');
export const createOtoMemory = data => api.post('/oto/memories', data);
export const reviseOtoMemory = (id, data) => api.post(`/oto/memories/${id}/revision`, data);
export const decideOtoMemory = (id, operation, version) => api.post(`/oto/memories/${id}/${operation}`, { confirmed: true, version });

export const streamOtoMessage = async (sessionId, text, onEvent, signal, editedFrom = null, attachmentIds = null) => {
  const headers = { 'Content-Type': 'application/json', 'X-OTO-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone };
  const org = localStorage.getItem('crm_org_id');
  if (org) headers['X-Org-Id'] = org;
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/oto/sessions/${sessionId}/messages`, {
    method: 'POST', credentials: 'include', headers, body: JSON.stringify({ text, ...(editedFrom ? { edited_from: editedFrom } : {}), ...(attachmentIds !== null ? { attachment_ids: attachmentIds } : {}) }), signal,
  });
  if (!response.ok) {
    let detail; try { detail = (await response.json()).detail; } catch { /* generic message below */ }
    throw new Error(typeof detail === 'string' ? detail : 'OTO est momentanément indisponible.');
  }
  if (!response.body) throw new Error('Votre navigateur ne peut pas recevoir cette réponse progressive.');
  const reader = response.body.getReader();
  const decoder = new TextDecoder(); let buffer = '';
  while (true) {
    const { value, done } = await reader.read();
    buffer += done ? decoder.decode() : decoder.decode(value, { stream: true });
    const frames = buffer.split('\n\n'); buffer = frames.pop();
    for (const frame of frames) {
      const line = frame.split('\n').find(item => item.startsWith('data: '));
      if (line) onEvent(JSON.parse(line.slice(6)));
    }
    if (done) break;
  }
};